import i18next from 'i18next';
import React from 'react';
import Lottie from 'react-lottie';
import { useParams } from 'react-router';
import { useSelector } from 'react-redux';

import LoadingWrapper from '~components/LoadingWrapper';
import { SIMULATION_TYPES } from '~components/CreditHeader/constants';
import { isConsumerSimulation } from '~models/simulations';
import { useFlowChoice } from '~app/hooks/useFlowChoice';
import { INCUMBENT_TYPES } from '~constants/incumbent';
import { ROUTES } from '~constants/routes';
import { isManualChoice } from '~utils/flowChoice';
import { getLottieOptions } from '~utils/lottie';
import welcome from '~assets/lotties/welcome.json';
import SimulationNewFlowWrapper from '~app/components/SimulationNewFlowWrapper';

import EvaluationChoices from './components/EvaluationChoices';
import GuarantorNotice from './components/GuarantorNotice';
import styles from './styles.module.scss';
import { PERSONAL_CREDIT } from './constants';

// ClaveÚnica -> native login; manual -> evaluation, as before this step existed.
const getStepNameByFlowChoice = flowChoice =>
  isManualChoice(flowChoice) ? ROUTES.EVALUATION_PENDING.stepName : ROUTES.CLIENT_UNIQUE_KEY_LOGIN.stepName;

const welcomeOptions = getLottieOptions({ loop: false, autoplay: true, animationData: welcome });

function ClientFlowChoice() {
  const { changeIncumbentLoading, clientFlowChoice } = useSelector(state => state.simulation);
  const { handleUniqueKeyChoice, handleManualChoice } = useFlowChoice({
    incumbent: INCUMBENT_TYPES.CLIENT,
    currentFlowChoice: clientFlowChoice,
    getStepNameByFlowChoice
  });
  const { kind } = useParams();
  const product = isConsumerSimulation(kind) ? PERSONAL_CREDIT : SIMULATION_TYPES[kind].name;
  return (
    <SimulationNewFlowWrapper
      previousStepName={ROUTES.CREDIT_SIMULATION.stepName}
      show={!changeIncumbentLoading}>
      <LoadingWrapper loading={changeIncumbentLoading}>
        <div className={styles.container}>
          <div className={styles.intro}>
            <div className={styles.illustration}>
              <Lottie options={welcomeOptions} />
            </div>
            <h1 className={styles.flowChoiceTitle}>
              {i18next.t('ClientFlowChoice:title', { product: product.toLowerCase() })}
            </h1>
            <p className={styles.flowChoiceSubtitle}>{i18next.t('ClientFlowChoice:subtitle')}</p>
            <GuarantorNotice />
          </div>
          <EvaluationChoices onUniqueKey={handleUniqueKeyChoice} onManual={handleManualChoice} />
        </div>
      </LoadingWrapper>
    </SimulationNewFlowWrapper>
  );
}

export default ClientFlowChoice;
